import { render, staticRenderFns } from "./mailings-form-iphone.vue?vue&type=template&id=e52fddd0&"
import script from "./mailings-form-iphone.vue?vue&type=script&lang=js&"
export * from "./mailings-form-iphone.vue?vue&type=script&lang=js&"
import style0 from "./mailings-form-iphone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports